import { StorefrontCategorySlug } from '@configs/storefront.config'

// Spline scenes
const TRAVEL_ANIMATION_SPLINE = 'https://prod.spline.design/PyNhCYOTGRB62pEr/scene.splinecode'
const CARD_DROP_ANIMATION_SPLINE = 'https://prod.spline.design/av5b4JEWbn8TLPZu/scene.splinecode'
const GIG_INSURANCE_SPLINE = 'https://prod.spline.design/hzdX0gQtF1CTs-2W/scene.splinecode'
const FINTECH_LOAN_PROTECTION_INSURANCE_SPLINE = 'https://prod.spline.design/2GZaAwwNGO8aeICI/scene.splinecode'
const ELECTRONIC_DEVICE_INSURANCE_SPLINE = 'https://prod.spline.design/sFmK8TPgubcYdxTc/scene.splinecode'

// Offset positions
const TRAVEL_ANIMATION_OFFSET_POSITIONS = {
  startTopOffset: 1,
  startLeftOffset: 0.5,
  endTopOffset: 2.2,
  endLeftOffset: 0.7,
}

const HEALTH_ANIMATION_OFFSET_POSITIONS = {
  startTopOffset: 0.76,
  startLeftOffset: 0.5,
  endTopOffset: 0.8,
  endLeftOffset: 0.52,
}

const GIG_INSURANCE_OFFSET_POSITIONS = {
  startTopOffset: 0.8,
  startLeftOffset: 0.5,
  endTopOffset: 0.93,
  endLeftOffset: 0.65,
}

const FINTECH_LOAN_PROTECTION_INSURANCE_OFFSET_POSITIONS = {
  startTopOffset: 0.74,
  startLeftOffset: 0.49,
  endTopOffset: 0.92,
  endLeftOffset: 0.33,
}

const ELECTRONIC_DEVICE_INSURANCE_OFFSET_POSITIONS = {
  startTopOffset: 0.82,
  startLeftOffset: 0.5,
  endTopOffset: 1.1,
  endLeftOffset: 0.64,
}

export const ANIMATION_DETAILS = {
  [StorefrontCategorySlug.TRAVEL_INSURANCE]: {
    offsetPositions: TRAVEL_ANIMATION_OFFSET_POSITIONS,
    spline: TRAVEL_ANIMATION_SPLINE,
    hideProgress: 0.8,
  },
  [StorefrontCategorySlug.HEALTH_INSURANCE]: {
    offsetPositions: HEALTH_ANIMATION_OFFSET_POSITIONS,
    spline: CARD_DROP_ANIMATION_SPLINE,
    hideProgress: 0.85,
  },
  [StorefrontCategorySlug.GIG_WORKER_HEALTH_INSURANCE]: {
    offsetPositions: GIG_INSURANCE_OFFSET_POSITIONS,
    spline: GIG_INSURANCE_SPLINE,
    hideProgress: 0.85,
  },
  [StorefrontCategorySlug.FINTECH_LOAN_PROTECTION_INSURANCE]: {
    offsetPositions: FINTECH_LOAN_PROTECTION_INSURANCE_OFFSET_POSITIONS,
    spline: FINTECH_LOAN_PROTECTION_INSURANCE_SPLINE,
    hideProgress: 0.83,
  },
  [StorefrontCategorySlug.ELECTRONIC_DEVICE_INSURANCE]: {
    offsetPositions: ELECTRONIC_DEVICE_INSURANCE_OFFSET_POSITIONS,
    spline: ELECTRONIC_DEVICE_INSURANCE_SPLINE,
    threshold: 3000,
    hideProgress: 0.9,
  },
}

export const MAX_RETRY_ATTEMPTS = 3
export const RETRY_DELAY = 2000
